import store from "@/store";

export const getCommitId = (questionnaireId: string) => {
    const { questionnaires, questionnaireCommits } = store.state.patient!;
    const questionnaire = questionnaires.find(q => q.id === questionnaireId);
    if(questionnaire && questionnaireCommits.includes(questionnaire.commit_id!))
        return questionnaire.commit_id;
}